import React from 'react';
import seventhSectionImage from '../assets/images/seventhSection.png';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './SeventhSection.css';

const SeventhSection = () => {
  // Scroll animations
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.6);
  const [textRef, isTextVisible] = useScrollAnimation(0.7);
  const [imageRef, isImageVisible] = useScrollAnimation(0.8);

  return (
    <section ref={sectionRef} className="seventh-section">
      <div className="seventh-container">
        <div className="seventh-content">
          <div ref={textRef} className={`seventh-text-column ${isTextVisible ? 'visible' : ''}`}>
            <h2 className={`seventh-title text-reveal ${isTextVisible ? 'visible' : ''}`}>
              <span className="title-line">YOUR IMPORT</span>
              <span className="title-line">PARTNER</span>
            </h2>
            <p className={`seventh-description text-reveal stagger-1 ${isTextVisible ? 'visible' : ''}`}>
              Indus Trade intends to break the bonds that have limited retailers from entering into direct importing by way of offering a single window solution to all their importing needs among other things. For stores, Architects, Interior Designers, Retailers and Wholesalers we take care of all your requirements from merchandising to shipping to delivery at your warehouse. And of-course volume that Indus turnovers contributes a great deal towards bringing those additional costs down to the benefit of the final dealer.
            </p>
          </div>
          <div ref={imageRef} className={`seventh-image-column ${isImageVisible ? 'visible' : ''}`}>
            <img src={seventhSectionImage} alt="Your Import Partner" className={`seventh-image image-reveal ${isImageVisible ? 'visible' : ''}`} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeventhSection;
